const URLS = {
  refreshToken: '/refresh_token',
  login: '/login',
  modPW: '/user/modpwd',
  dict: '/getDict', // 数据字典
  roleDict: 'getRoleDict',
  idCode: '/getIDCode',
  menuTree: '/getTreeRes',
  getID: '/getID',
  // 附件管理
  attUpload: '/att/upload',
  attDel: '/att/del',
  attDown: '/att/download',
  attList: '/att/list',
  // 上传
  impDo: '/imp/do',
  impPage: '/imp/page',
  impDownTemp: '/imp/downtemp',
  impDownHis: '/imp/downhis',
  // 角色管理
  roleList: '/role/list',
  roleAdd: '/role/add',
  roleInfo: '/role/info',
  roleMod: '/role/mod',
  roleDel: '/role/del',
  roleExp: '/role/exp',
  rolePage: '/role/page',
  // 用户管理
  userList: '/user/list',
  userPage: '/user/page',
  userAdd: '/user/add',
  userInfo: '/user/info',
  userMod: '/user/mod',
  userLock: '/user/lock',
  userClearLock: '/user/clearlock',
  userClose: '/user/close',
  userBatchClose: '/user/batchclose',
  userInitPwd: '/user/initpwd',
  userAuthTree: '/user/authTree',
  userRoleCal: '/user/roleCal',
  userExp: '/user/exp',
  // 日志查询
  loginLogList: '/loginLog/list',
  userLogList: '/userLog/list',
  // 分类码
  dictPage: '/dict/page',
  dictSave: '/dict/save',
  dictInfo: '/dict/info',
  dictDel: '/dict/del',
  dictDataDel: '/dict/data/del',
  // 消息
  newsPage: '/news/page',
  newsSave: '/news/save',
  newsInfo: '/news/info',
  newsDel: '/news/del',
  newsOff: '/news/off',
  // 客户
  custPage: '/cust/page',
  custSave: '/cust/save',
  custInfo: '/cust/info',
  custDel: '/cust/del',
  custDict: '/custDict',
  custContSave: '/cust/cont/save',
  custContInfo: '/cust/cont/info',
  custContPage: '/cust/cont/list',
  custContDel: '/cust/cont/del',
  custExp: '/cust/exp',
  // 设备
  deviceSave: '/machine/save',
  devicePage: '/machine/page',
  deviceDict: '/machineTypeCodeDict',
  deviceInfo: '/machine/info',
  deviceDel: '/machine/del',
  deviceScrap: '/machine/scrap',
  deviceFrozen: '/machine/frozen',
  deviceFrozenPage: '/machine/pagefrozen',
  // 设备维修
  maintenSave: '/maintenance/save',
  maintenInfo: '/maintenance/info',
  maintenDel: '/maintenance/del',
  maintenPage: '/maintenance/list',
  // 备件
  partsPage: '/parts/stock/page',
  partsIn: '/parts/in',
  partsOut: '/parts/out',
  partsInfo: '/parts/info',
  partsListio: '/parts/listio',
  partsDel: '/parts/del',
  // 电费
  pricePage: '/elec/price/page',
  priceSave: '/elec/price/save',
  priceInfo: '/elec/price/info',
  priceDel: '/elec/price/del',
  elecFeePage: '/elec/fee/page',
  // 收益
  incomePage: '/pool/income/page',
  incomeSave: '/pool/income/save',
  incomeInfo: '/pool/income/info',
  incomeDel: '/pool/income/del',
  incomeProcess: '/pool/income/process',
  custIncomePage: '/cust/income/page',
  // 提现
  custBalance: '/cust/balance/page',
  withdrawSave: '/withdraw/save',
  withdrawList: '/withdraw/list',
  withdrawDel: '/withdraw/del',
  // 行情
  quotePage: '/quote/page',
  quoteSave: '/quote/save',
  quoteDel: '/quote/del',
  // 汇率
  exratePage: '/exrate/page',
  exrateSave: '/exrate/save',
  exrateDel: '/exrate/del',
  // 租金
  rentPage: '/rent/page',
  rentPayed: '/rent/payed',
  rentMod: '/rent/mod',
  rentDel: '/rent/del'
}
const Actions = {
  sys: {
    role: {
      list: 'M101010401',
      add: 'M101010402',
      info: 'M101010403',
      mod: 'M101010404',
      del: 'M101010405',
      exp: 'M101010406'
    },
    user: {
      list: 'M101010501',
      add: 'M101010502',
      info: 'M101010503',
      mod: 'M101010504',
      lock: 'M101010505',
      clearLock: 'M101010506',
      close: 'M101010507',
      initPwd: 'M101010508',
      exp: 'M101010509',
      authTree: 'M101010510',
      roleCal: 'M101010511',
      modifyPwd: 'WFC'
    },
    loginLog: {
      list: 'M101030101'
    },
    userLog: {
      list: 'M101030201'
    },
    dict: {
      list: 'M101010901',
      add: 'M101010902',
      info: 'M101010903',
      mod: 'M101010904',
      del: 'M101010905'
    }
  },
  news: {
    list: 'M103010001',
    add: 'M103010002',
    info: 'M103010003',
    mod: 'M103010004',
    off: 'M103010005'
  },
  cust: {
    list: 'M103020001',
    add: 'M103020002',
    info: 'M103020003',
    mod: 'M103020004',
    del: 'M103020005',
    upload: 'M103020006',
    machine: 'M103020007',
    profit: 'M103020008',
    exp: 'M103020009'
  },
  device: {
    list: 'M103030001',
    add: 'M103030002',
    info: 'M103030003',
    mod: 'M103030004',
    del: 'M103030005',
    mainten: 'M103030006',
    record: 'M103030007',
    scrap: 'M103030008',
    frozen: 'M103030009',
    unfreeze: 'M103030010'
  },
  parts: {
    list: 'M103040001',
    in: 'M103040002',
    info: 'M103040003',
    mod: 'M103040004',
    del: 'M103040005',
    out: 'M103040006'
  },
  price: {
    list: 'M103090101',
    add: 'M103090102',
    info: 'M103090103',
    mod: 'M103090104',
    del: 'M103090105'
  },
  quote: {
    list: 'M103090201',
    save: 'M103090202',
    del: 'M103090203'
  },
  exrate: {
    list: 'M103090301',
    save: 'M103090302',
    del: 'M103090303'
  },
  poolIncome: {
    list: 'M103050101',
    add: 'M103050102',
    info: 'M103050103',
    mod: 'M103050104',
    del: 'M103050105'
  },
  custIncome: {
    list: 'M103050201'
  },
  rent: {
    list: 'M103050401',
    payed: 'M103050402',
    del: 'M103050403',
    mod: 'M103050404'
  },
  withdraw: {
    list: 'M103050301',
    save: 'M103050302',
    del: 'M103050305'
  },
  elecfee: {
    list: 'M103050501',
    imp: 'M103050502'
  }
}
export default URLS
export { Actions }



// WEBPACK FOOTER //
// ./src/assets/js/urls.js